export function erroCelulaGridServicos(params, inputErros) {
  if (!inputErros || !params) return "";
  const indiceItem = params.api.getRowIndexRelativeToVisibleRows(params.row.id);
  return inputErros.get(`[${indiceItem}].${params.field}`);
}